export default __webpack_public_path__ + "static/media/closeIcon.a8e5598f.svg";